import { PasswordFormData } from "./types";

export const DEFAULT_PASSWORD: PasswordFormData = {
  currentPassword: "",
  newPassword: "",
  confirmPassword: "",
};

export const profileValidationRules = {
  firstName: {
    required: "First Name is required",
    minLength: {
      value: 3,
      message: "First Name must be at least 3 characters",
    },
    maxLength: {
      value: 100,
      message: "First Name cannot exceed 100 characters",
    },
  },
  lastName: {
    required: "Last Name is required",
    minLength: { value: 3, message: "Last Name must be at least 3 characters" },
    maxLength: {
      value: 100,
      message: "Last Name cannot exceed 100 characters",
    },
  },
  email: {
    required: "Email is required",
    pattern: {
      value: /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/,
      message: "Enter a valid email address",
    },
  },
  phone: {
    pattern: {
      value: /^\+?\(?\d{1,4}\)?[-\s./\d]*$/,
      message: "Enter a valid phone number",
    },
  },
  dateOfBirth: {
    required: "Date of birth is required",
    validate: (value: string) => {
      if (!value) return "Date of birth is required";
      const date = new Date(value);
      if (Number.isNaN(date.getTime())) return "Invalid date format";
      if (date > new Date()) return "Date of birth cannot be in the future";
      return true;
    },
  },
};

export const passwordValidationRules = (passwordForm: any) => ({
  currentPassword: {
    required: "Password is required",
  },
  newPassword: {
    required: "New password is required",
    minLength: {
      value: 8,
      message: "New password must be at least 8 characters",
    },
    pattern: {
      value: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^\w\s]).+$/,
      message:
        "Password must contain uppercase, lowercase, number, and special character",
    },
    validate: (value: string) => {
      const currentPassword = passwordForm.getValues("currentPassword");
      return (
        value !== currentPassword ||
        "New password must be different from current password"
      );
    },
  },
  confirmPassword: {
    required: "Please confirm your new password",
    validate: (value: string) => {
      const newPassword = passwordForm.getValues("newPassword");
      return value === newPassword || "Passwords do not match";
    },
  },
});
